import { render, staticRenderFns } from "./ManageLocations.vue?vue&type=template&id=81b85cb0"
import script from "./ManageLocations.vue?vue&type=script&lang=ts"
export * from "./ManageLocations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports